import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

// jQuery plugins are provided by the legacy SPA build (public/build.js) enqueued before this bundle.
// Avoid bundling them again here to keep the theme build small and fast.

// Reuse utilities from the existing SPA source
import cssMediaQueryHelper from '../vue-src/services/cssMediaQueryHelper';
import storage from '../vue-src/services/storage';
import wpApi from '../vue-src/services/wpApi';

// Import all Vue components
import App from '../vue-src/App.vue';
import AppFooter from '../vue-src/components/AppFooter.vue';
import AppMenu from '../vue-src/components/AppMenu.vue';
import Article from '../vue-src/components/Article.vue';
import ArticleAccordion from '../vue-src/components/ArticleAccordion.vue';
import ArticleAccordionCollapsible from '../vue-src/components/ArticleAccordionCollapsible.vue';
import BackToTop from '../vue-src/components/BackToTop.vue';
import Category from '../vue-src/components/Category.vue';
import ErrorNotFound from '../vue-src/components/ErrorNotFound.vue';
import Features from '../vue-src/components/Features.vue';
import FeaturesWide from '../vue-src/components/FeaturesWide.vue';
import Glossary from '../vue-src/components/Glossary.vue';
import Home from '../vue-src/components/Home.vue';
import HomeHeader from '../vue-src/components/HomeHeader.vue';
import HomeHeaderHero from '../vue-src/components/HomeHeaderHero.vue';
import Infomaterialien from '../vue-src/components/Infomaterialien.vue';
import LoadMore from '../vue-src/components/LoadMore.vue';
import LoadingSpinner from '../vue-src/components/LoadingSpinner.vue';
import PopupAccordion from '../vue-src/components/PopupAccordion.vue';
import PopupExternalLink from '../vue-src/components/PopupExternalLink.vue';
import Questions from '../vue-src/components/Questions.vue';
import Rating from '../vue-src/components/Rating.vue';
import ReferenzComponent from '../vue-src/components/ReferenzComponent.vue';
import SearchResults from '../vue-src/components/SearchResults.vue';
import TabbedTeaser from '../vue-src/components/TabbedTeaser.vue';
import Tags from '../vue-src/components/Tags.vue';
import Teaser from '../vue-src/components/Teaser.vue';
import TeaserGroup from '../vue-src/components/TeaserGroup.vue';
import TeaserWide from '../vue-src/components/TeaserWide.vue';
import Topic from '../vue-src/components/Topic.vue';
import ContentHivInfoGraphic from '../vue-src/components/content/ContentHivInfoGraphic.vue';
import ContentNewVideo from '../vue-src/components/content/ContentNewVideo.vue';
import StickyQuestionnaire from '../vue-src/components/content/StickyQuestionnaire.vue';

Vue.use(VueRouter);

// Add theme URL as global property
Vue.prototype.$themeUrl = themeData.themeUrl || '/wp-content/themes/nochvielvor-site';

// Minimal router so <router-link> works in components
const router = new VueRouter({
  mode: 'history',
  routes: [],
});

// Configure API endpoints - WordPress is now at root, not /wp/
wpApi.baseUrl = process.env.WP_BASE_URL || '';
wpApi.host = window.location.protocol + '//' + window.location.host;
// Use axios for custom API endpoints (NOT WordPress REST API)
wpApi.http = axios;

// Set up responsive helper like in SPA
cssMediaQueryHelper.mediaQueries = [
  function (watch) {
    watch.factor = 1;
    watch.isPhone = window.matchMedia('(max-width: 767px)').matches;
  },
  function (watch) {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      watch.factor = 1.25;
    }
  },
  function (watch) {
    if (window.matchMedia('(min-width: 1440px)').matches) {
      watch.factor = 1.5;
    }
  },
  function (watch) {
    if (window.matchMedia('(min-width: 1920px)').matches) {
      watch.factor = 2;
    }
  },
  function (watch) {
    if (window.matchMedia('(min-width: 2400px)').matches) {
      watch.factor = 2.5;
    }
  },
];
cssMediaQueryHelper.watch = { factor: 1, isPhone: false };
cssMediaQueryHelper.addListener();

// Shared root-like state so components expecting this.$root.states/events work
const sharedRoot = {
  cache: Object.assign({ menus: {}, options: {}, tags: { primary_keyword: [], series_keyword: [], sequencing_keyword: [] } }, storage.cache || {}),
  events: new Vue(),
  promises: {
    tags: Promise.resolve(), // Create resolved promise so Article.vue doesn't crash
    menus: Promise.resolve(),
    options: Promise.resolve(),
  },
  states: Object.assign({
    glossaryIsShown: false,
    menuIsActive: false,
    popupAccordionData: null,
    popupAccordionId: null,
    popupExternalLinkHref: null,
    previousSearchValue: '',
    searchResultsAreShown: false,
    searchResultsReferrer: null,
    searchValue: '',
    viewIsScrolled: false,
    articleHasVideo: false,
  }, storage.states || {}),
};

// Registry of components available for server-side mounting
const registry = {
  AppFooter,
  AppMenu,
  Article,
  ArticleAccordion,
  ArticleAccordionCollapsible,
  BackToTop,
  Category,
  ContentHivInfoGraphic,
  ContentNewVideo,
  ErrorNotFound,
  Features,
  FeaturesWide,
  Glossary,
  Home,
  HomeHeader,
  HomeHeaderHero,
  Infomaterialien,
  LoadMore,
  LoadingSpinner,
  PopupAccordion,
  PopupExternalLink,
  Questions,
  Rating,
  ReferenzComponent,
  SearchResults,
  StickyQuestionnaire,
  TabbedTeaser,
  Tags,
  Teaser,
  TeaserGroup,
  TeaserWide,
  Topic,
};

function parseProps(el) {
  const json = el.getAttribute('data-vue-props') || '{}';
  try {
    return JSON.parse(json);
  } catch (e) {
    console.warn('Invalid JSON in data-vue-props:', e, json);
    return {};
  }
}

function mountEl(el) {
  const name = el.getAttribute('data-vue-component');
  const Cmp = registry[name];
  if (!Cmp) {
    console.warn('Unknown Vue component:', name);
    return;
  }
  const propsData = parseProps(el);

  // Create a minimal root that exposes shared data like in the SPA
  /* eslint-disable no-new */
  new Vue({
    router,
    data: sharedRoot,
    render(h) {
      return h(Cmp, { props: propsData });
    },
  }).$mount(el);
}

function mountAll() {
	const appEl = document.getElementById('app');

	if (!appEl) {
		console.warn('No #app element found');
		return;
	}

	// Check if there's a page component to render
	const pageComponentEl = appEl.querySelector('[data-vue-component]');
	let pageComponent = null;
	let pageProps = {};

	if (pageComponentEl) {
		const componentName = pageComponentEl.getAttribute('data-vue-component');
		pageComponent = registry[componentName];

		const propsJson = pageComponentEl.getAttribute('data-vue-props') || '{}';
		try {
			pageProps = JSON.parse(propsJson);
		} catch (e) {
			console.warn('Invalid JSON in data-vue-props:', e, propsJson);
		}
	}

	// Get menus and footer data from themeData (set by PHP)
	const menus = (typeof themeData !== 'undefined' && themeData.menus) ? themeData.menus : {};
	const tags = (typeof themeData !== 'undefined' && themeData.tags) ? themeData.tags : [];
	const footerData = (typeof themeData !== 'undefined' && themeData.footerData) ? themeData.footerData : {};

	// Mount App.vue which wraps everything
	new Vue({
		router,
		data: sharedRoot,
		provide() {
			return {
				themeUrl: themeData.themeUrl || '/wp-content/themes/nochvielvor-site'
			}
		},
		render(h) {
			// Pass the page component, props, menus, and footer data to App
			return h(App, {
				props: {
					pageComponent,
					pageProps,
					menus,
					tags,
					footerData
				}
			});
		},
	}).$mount(appEl);
}

function mountAllOld() {
	const nodes = document.querySelectorAll('[data-vue-component]');
	nodes.forEach(mountEl);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountAll);
} else {
  mountAll();
}
